import styled from 'styled-components';

export const ToolTipBox = styled.div<{
  position?: { top?: string; right?: string; bottom?: string; left?: string };
  width?: string;
}>`
  visibility: hidden;
  position: absolute;
  top: ${(props) => props.position?.top ?? 'auto'};
  right: ${(props) => props.position?.right ?? 'auto'};
  bottom: ${(props) => props.position?.bottom ?? 'auto'};
  left: ${(props) => props.position?.left ?? 'auto'};
  width: ${(props) => props.width ?? 'auto'};
`;

export const HoverElement = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

export const Container = styled.div`
  & ${HoverElement}:hover + ${ToolTipBox} {
    visibility: visible;
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.default};
    color: ${(props) => props.theme.atlas.semantic.color.type.default};
    font-size: 12px;
    padding: 5px;
    box-shadow: -2px 2px 10px 3px
      ${(props) => props.theme.atlas.semantic.color.outline.default};
    z-index: 2;
  }
`;
